import { FC } from 'react';
import styles from './index.module.less';
import mobxWrap from '@/components/MobxWrap';

const Search: FC = mobxWrap(['meta', 'search'], ({ search, meta }) => {
  const svgUrl = meta.navCurStyle?.searchIcon || '';
  const { toggleSearchBar } = search;
  return (
    <div className={styles.icon} onClick={toggleSearchBar}>
      <img src={svgUrl} alt='' />
    </div>
  );
});

export default Search;
